import React from 'react';
import Clients from '../components/Clients';
import Cta from '../components/Cta';
import Strengths from '../components/strengths';
import Footer from '../components/Footer';
import Hero from '../components/Home_pg';
import Intro from '../components/About';
import Portfolio from '../components/Products';
import Services from '../components/Services';
import Team from '../components/Teams';

const Home = () => {
    return (
        <>
            <Hero />
            <Intro />
            <Strengths />
            <Services />
            <Portfolio />
            <Clients />
            <Team/>
            <Cta/>
            <Footer />
        </>

    )
}

export default Home;

